(function () {
    'use strict';

    angular
        .module('app.productLists')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [{
                state: 'productLists',
                config: {
                    url: '/productLists',
                    title: 'Ürün Listesi',
                    abstract: true,
                    templateUrl: 'app/productLists/productLists.html'
                }
            },
            {
                state: 'productLists.list',
                config: {
                    templateUrl: 'app/productLists/productLists.list.html',
                    controller: 'ProductListsListController',
                    controllerAs: 'vm',
                    url: '/list',
                    title: 'Ürün Listesi',
                    settings: {
                        nav: 4,
                        name: 'productLists.list',
                        topName: 'system',
                        content: 'Ürün Listesi',
                        resource: 'menu.productLists.list'
                    }
                }
            }
        ];
    }
})();